import React from 'react';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { STATUS_COLORS, SKILL_CHIP } from './constants';

export const ApplicationsList = ({ applications, onViewDetails }) => {
  if (applications.length === 0) {
    return (
      <div className="empty-state" style={{ paddingTop: '3rem' }}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ width: 48, height: 48 }}>
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
        </svg>
        <p style={{ marginTop: '1rem', marginBottom: '1rem' }}>You haven't applied to any jobs yet.</p>
        <p style={{ fontSize: '0.8125rem', color: '#94A3B8' }}>Browse open positions and submit your resume to get started.</p>
      </div>
    );
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
      {applications.map(app => {
        const sc = STATUS_COLORS[app.status] || STATUS_COLORS.applied;
        return (
          <Card key={app._id} data-testid="application-card" style={{ background: '#fff', border: '1px solid #ECE7DE', borderRadius: 14, padding: '1.25rem' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
              <div>
                <h3 style={{ fontFamily: 'Cabinet Grotesk', fontSize: '1rem', fontWeight: 600, color: '#002A38' }}>{app.job_title}</h3>
                <p style={{ fontSize: '0.75rem', color: '#64748B' }}>{app.job_location} &middot; {app.job_type}</p>
              </div>
              <Badge style={{ background: sc.bg, color: sc.color, borderRadius: 999, fontSize: '0.6875rem', border: 'none' }}>
                {sc.label}
              </Badge>
            </div>
            <p style={{ fontSize: '0.8125rem', color: '#64748B', marginBottom: '0.75rem', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
              {app.job_description}
            </p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.375rem', marginBottom: '0.75rem' }}>
              {(app.required_skills || []).slice(0, 5).map(s => (
                <span key={s} style={SKILL_CHIP}>{s}</span>
              ))}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '0.75rem', color: '#94A3B8' }}>
              <span>Resume: {app.filename}</span>
              <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <span>Applied: {new Date(app.applied_at).toLocaleDateString()}</span>
                <Button
                  data-testid="view-application-button"
                  onClick={() => onViewDetails(app.job_id)}
                  style={{ background: '#0076A3', color: '#fff', borderRadius: 8, fontSize: '0.75rem', fontWeight: 600, padding: '0.375rem 0.75rem' }}
                >
                  View Details
                </Button>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};

export const BrowseJobs = ({ jobs, onApply }) => {
  if (jobs.length === 0) {
    return (
      <div className="empty-state" style={{ paddingTop: '3rem' }}>
        <p>No open positions available right now. Check back soon!</p>
      </div>
    );
  }
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))', gap: '1rem' }}>
      {jobs.map(job => (
        <Card key={job._id} data-testid="browse-job-card" style={{ background: '#fff', border: '1px solid #ECE7DE', borderRadius: 14, padding: '1.25rem', display: 'flex', flexDirection: 'column' }}>
          <h3 style={{ fontFamily: 'Cabinet Grotesk', fontSize: '1.0625rem', fontWeight: 600, marginBottom: '0.375rem', color: '#002A38' }}>{job.title}</h3>
          <p style={{ fontSize: '0.75rem', color: '#64748B', marginBottom: '0.5rem' }}>{job.location || 'Remote'} &middot; {job.job_type} &middot; {job.experience_years || 0}+ years</p>
          <p style={{ fontSize: '0.8125rem', color: '#64748B', marginBottom: '0.75rem', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden', flex: 1 }}>
            {job.description}
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.375rem', marginBottom: '1rem' }}>
            {(job.required_skills || []).slice(0, 5).map(s => (
              <span key={s} style={SKILL_CHIP}>{s}</span>
            ))}
          </div>
          <Button
            data-testid="apply-now-button"
            onClick={() => onApply(job)}
            style={{ background: '#0076A3', color: '#fff', borderRadius: 999, fontWeight: 600, fontSize: '0.875rem', width: '100%' }}
          >
            Apply Now
          </Button>
          <p data-testid="aedt-card-notice" style={{ fontSize: '0.625rem', color: '#94A3B8', marginTop: '0.5rem', textAlign: 'center', lineHeight: 1.5 }}>
            AI may be used to assess applications.{' '}
            <a href="/ai-transparency" target="_blank" rel="noopener noreferrer" style={{ color: '#0076A3', fontWeight: 600 }}>How AI is used</a>
          </p>
        </Card>
      ))}
    </div>
  );
};
